<template>
    <table class="sortable-table search-results table">
        <thead>
            <tr>
                <th v-for="(label, key) in columns"
                    @click="sortBy(key)"
                    :class="{ active: sortKey == key }">{{ getLabel(key) }}<span class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'"></span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="entry in filteredData" v-on:click="performAction(entry)">
                <td v-for="(label, key) in columns" v-html="renderCell(entry, key)"></td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        props: {
            data: Array,
            columns: Object,
            action: String
        },
        data: function () {
            var sortOrders = {}
            for (let key in this.columns) {
                sortOrders[key] = -1
            }
            return {
                sortKey: '',
                sortOrders: sortOrders
            }
        },
        computed: {
            filteredData: function () {
                var sortKey = this.sortKey
                var order = this.sortOrders[sortKey] || -1
                var data = this.data
                if (sortKey) {
                    data = data.slice().sort(function (a, b) {
                        a = a[sortKey]
                        b = b[sortKey]
                        return (a === b ? 0 : a > b ? 1 : -1) * order
                    })
                }
                return data
            }
        },
        methods: {
            sortBy: function (key) {
                this.sortKey = key
                this.sortOrders[key] = this.sortOrders[key] * -1
            },
            performAction: function (row) {
                if (this.action !== undefined) {
                    this.$emit(this.action, row.id || 0)
                }
            },
            getLabel (column) {
                if (typeof this.columns[column] === 'object') {
                    return this.columns[column].label
                } else {
                    return this.columns[column]
                }
            },
            renderCell (value, key) {
                let field = value[key]
                if (Array.isArray(field)) {
                    field = field.join('<br/>')
                }

                let restricted = value['restricted'] || false
                if (typeof this.columns[key] === 'object' && this.columns[key].link !== undefined && !restricted) {
                    let link = this.columns[key].link
                    for (let key in value) {
                        link = link.replace('{' + key + '}', value[key] || '')
                    }

                    field = '<a href="' + link + '">' + field + '</a>'
                }

                return field
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// SortableTable.vue?5d2e899e